"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleInvoice = void 0;
var simpleInvoice = {
    caseType: "PLAYGROUND",
    cancelled: false,
    tenantId: { uuid: "BB1EA38B-7AB4-4498-A0B2-E2FD3CB029A4" },
    healthSystemTenantId: { uuid: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59" },
    guid: { uuid: "613ad98a-cb89-4b01-abd7-d37f72d63dc9" },
    serviceLine: "RADIOLOGY",
    invoices: [
        {
            guid: "49adac16-6084-405a-aadc-c1a8bd7e1a8d",
            type: "assembled",
            date_of_service: "2021-09-20",
            place_of_service: "CMX",
            billing_area: "Pulmonology",
            billing_provider_name: "Ghamloush, Maher, MD",
            billing_provider_number: {
                number: "1709402",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: "null",
            ordering_provider_number: {
                number: "1001071",
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            rendering_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: "null",
            performing_provider_number: {
                number: "1709402",
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [
                {
                    guid: "01e46fdd-20a2-4dbc-b8b9-b4aaaf3636d9",
                    transaction_id: "1",
                    procedure: {
                        procedure_id: null,
                        procedure_name: "some procedure",
                        procedure_code: "74018",
                        threashold: 0.0,
                        type: null,
                        units: 4.7,
                        sequence_number: 1,
                        transaction_id: null,
                        automate: false,
                        confidence: 0.0,
                        evidence: [],
                        used: false,
                        id: 12
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "R91.8",
                            automate: false,
                            confidence: 0.0,
                            sequence_number: 1,
                            type: null,
                            evidence: [],
                            used: true
                        }
                    ]
                }
            ],
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        }
    ],
    status: "SUBMITTED"
};
exports.simpleInvoice = simpleInvoice;
//# sourceMappingURL=simple-invoice.js.map